import { useTranslations } from "next-intl";

import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";

import SeriesCard from "./SeriesCard";
import styles from "./seriesCards.module.scss";

type Props = { series: VariantPage["relatedSeries"] };

const UI = ({ series: seriesArray }: Props = { series: [] }) => {
  const t = useTranslations();
  return (
    <div className={styles.container}>
      {seriesArray && seriesArray.length > 0 && (
        <p className={styles.title}>{t("shopTheSeries")}</p>
      )}
      <div className={styles.cardContainer}>
        {seriesArray?.map((series) => (
          <div className={styles.card} key={`${series.uri}-series-card`}>
            <SeriesCard {...series} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UI;
